// 配镜流程独有的常量

// 各步骤组件
export const PRESCRIPTION_TYPE_COMPONENT = 'prescriptionTypeComponent';
export const EDIT_PRESCRIPTION_COMPONENT = 'editPrescriptionComponent';
export const LENS_TYPE_COMPONENT = 'lensTypeComponent';
export const LENS_INDEX_COMPONENT = 'lensIndexComponent';
export const LENS_VIEW_AREA_COMPONENT = 'lensViewAreaComponent';
export const COATING_COMPONENT = 'coatingComponent';

/** 配镜步骤顺序，供 LensInfo 等按当前步骤控制信息区块展示 */
const LENS_PROCESS_COMPONENT_RANK: Record<string, number> = {
  [PRESCRIPTION_TYPE_COMPONENT]: 0,
  [EDIT_PRESCRIPTION_COMPONENT]: 1,
  [LENS_TYPE_COMPONENT]: 2,
  [LENS_INDEX_COMPONENT]: 3,
  [LENS_VIEW_AREA_COMPONENT]: 4,
  [COATING_COMPONENT]: 5,
};

/** 当前步骤是否已达到或超过目标步骤（未识别步骤视为未达到） */
export function hasReachedLensProcessStep(nowComponent: string, targetComponent: string): boolean {
  const nowRank = LENS_PROCESS_COMPONENT_RANK[nowComponent];
  const targetRank = LENS_PROCESS_COMPONENT_RANK[targetComponent];
  if (nowRank == null || targetRank == null) return false;
  return nowRank >= targetRank;
}

//  部分leave事件进行下线
export const LENS_PROCESS_COMPONENT_LEAVE_EVENT_NAME = {
  // [PRESCRIPTION_TYPE_COMPONENT]: 'PrescriptionTypePage_Leave',
  // [EDIT_PRESCRIPTION_COMPONENT]: 'PrescriptionEnterPage_Leave',
  // [LENS_TYPE_COMPONENT]: 'LensTypePage_Leave',
  // [LENS_INDEX_COMPONENT]: 'LensIndexPage_Leave',
  [LENS_VIEW_AREA_COMPONENT]: 'ViewAreaPage_Leave',
  // [COATING_COMPONENT]: 'CoatingPage_Leave',
};

export const LENS_PROCESS_COMPONENT_CLOSE_NAME = {
  [PRESCRIPTION_TYPE_COMPONENT]: '处方类型页',
  [EDIT_PRESCRIPTION_COMPONENT]: '处方输入页',
  [LENS_TYPE_COMPONENT]: '镜片类型页',
  [LENS_INDEX_COMPONENT]: '镜片折射率页',
  [LENS_VIEW_AREA_COMPONENT]: '视野范围页',
  [COATING_COMPONENT]: '镀膜页',
};

export const LENS_COLOR = {
  NON: 'non',
};

export const ZL_PRESCRIPTION_DATA = 'zl-presData';

/** 配镜流程默认勾选 — 上次各步选中项（小语种魔方 prescription_default_selection） */
export const ZL_PREV_PRESCRIPTION_SELECTION = 'zl-prevPrescriptionData';

// 神策埋点老花镜类型(神策跟接口返回的二级老化没有统一，这里单独定义)
export const SENSOR_READERS_PRESCRIPTION_TYPE = 'Reading Non-Prescription';

export const EDIT_PRESCRIPTION_SUB_STEPS = {
  SELECT_METHODS: 0,
  CHOOSE_PRESCRIPTION: 1,
  PRESCRIPTION_RECOGNITION: 2,
  FILL_PRESCRIPTION_FORM: 3,
};
//  * 处方选择方式
export const PRESCRIPTION_METHODS = {
  CHOOSE_PRESCRIPTION: 1,
  SCAN_PRESCRIPTION: 2,
  FILL_PRESCRIPTION: 3,
};

export const StepTextMap = {
  [EDIT_PRESCRIPTION_SUB_STEPS.CHOOSE_PRESCRIPTION]: 'Choose Prescription',
  [EDIT_PRESCRIPTION_SUB_STEPS.PRESCRIPTION_RECOGNITION]: 'Scan Prescription',
  [EDIT_PRESCRIPTION_SUB_STEPS.FILL_PRESCRIPTION_FORM]: 'Fill It Out',
};
